import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { GridRegistrationModel } from '@bo-client/activation-management/grid-registration/model/grid-registration.model';
import { ConfirmationRequestFormBase } from '@bo-client/shared/base-components/confirmation-request-form.base';
import { AuthenticationService } from '@bo-client/core';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { ErrorsFormsService } from '@bo-client/shared/form-errors/errors-forms.service';
import { CreateFormsGrPlaceinserviceService } from '@bo-client/activation-management/grid-registration/forms/create-forms-gr-placeinservice.service';

@Component({
  selector: 'app-gr-place-in-service-confirmation-form',
  templateUrl: './gr-place-in-service-confirmation-form.component.html',
  styleUrls: ['./gr-place-in-service-confirmation-form.component.scss']
})
export class GrPlaceInServiceConfirmationFormComponent
  extends ConfirmationRequestFormBase<GridRegistrationModel>
  implements OnInit, OnDestroy
{
  @Output() onErrorsChanged = new EventEmitter<any>();
  public compUnsubs$ = new Subject<void>();
  private gridRegistrationModel: GridRegistrationModel;

  public constructor(
    protected authenticationService: AuthenticationService,
    protected dataShareService: DataShareService,
    protected errorsFormsService: ErrorsFormsService,
    protected createFormsGrPlaceinserviceService: CreateFormsGrPlaceinserviceService
  ) {
    super(authenticationService, dataShareService, errorsFormsService);
  }
  ngOnInit(): void {}

  loadFormWithModel(result: GridRegistrationModel) {
    this.gridRegistrationModel = result;
    this.formGroup = this.createFormsGrPlaceinserviceService.createPlaceInServiceConfirmationForm();
  }

  hookErrors() {
    // entry Point to check specific errors
    console.log('emitting errors', this.errorFormList);
    this.onErrorsChanged.emit(this.errorFormList);
  }

  ngOnDestroy() {
    this.compUnsubs$.next();
    this.compUnsubs$.complete();
  }
}
